/*  ========================================================================
    # Scripts - Overflow swipe icon
    ========================================================================  */

/**
 * Script that handles the display of the animated swipe icon.
 */

const HeaderContrastToggle = {
  cfg: {
    contrastToggle: document.querySelector('.c-header__contrast-toggle')
  },

  /**
   * Check if high contrast mode is enabled.
   */

  isHighContrastModeEnabled() {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('tkHighContrastMode='));
    return cookieValue ? cookieValue.split('=')[1] === '1' : false;
  },

  /**
   * Handle toggle contrast class
   */
  handleContrastToggleClick() {
    if (this.cfg.contrastToggle.classList.contains('c-header__contrast-toggle--active')) {
      this.disableHighContrastMode();
    } else {
      this.enableHighContrastMode();
    }
  },

  /**
   * Enable high contrast mode.
   */

  enableHighContrastMode() {
    document.body.classList.add('u-high-contrast');
    this.cfg.contrastToggle.classList.add('c-header__contrast-toggle--active');
    document.cookie = 'tkHighContrastMode=1; path=/; max-age=31536000';
    this.cfg.contrastToggle.setAttribute('aria-checked', true);
  },

  /**
   * Disable high contrast mode.
   */
  disableHighContrastMode() {
    document.body.classList.remove('u-high-contrast');
    this.cfg.contrastToggle.classList.remove('c-header__contrast-toggle--active');
    document.cookie = 'tkHighContrastMode=0; path=/; max-age=31536000';
    this.cfg.contrastToggle.setAttribute('aria-checked', false);
  },

  /**
   * Initialize.
   */
  init() {
    if (this.isHighContrastModeEnabled()) {
      this.enableHighContrastMode();
    }

    if (this.cfg.contrastToggle) {
      this.cfg.contrastToggle.addEventListener('click', () => {
        this.handleContrastToggleClick();
      });
    }
  }
};

export default HeaderContrastToggle;
